'use client';
import { jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import 'classnames';
import '../../server-components/Table/components/HeaderCell.module.scss.js';
import Flex from '../../server-components/layout/Flex/Flex.js';
import '../../server-components/layout/Row/Row.module.scss.js';
import '../../server-components/layout/Stack/Stack.js';
import Box from '../../server-components/layout/Box/Box.js';
import '../../server-components/icons/ActivityIcon.js';
import '../../server-components/icons/ArrowDownIcon.js';
import '../../server-components/icons/ArrowDownRightCircleIcon.js';
import '../../server-components/icons/ArrowLeftAlignIcon.js';
import '../../server-components/icons/ArrowLeftIcon.js';
import '../../server-components/icons/ArrowRightAlignIcon.js';
import '../../server-components/icons/ArrowRightIcon.js';
import '../../server-components/icons/ArrowUpIcon.js';
import '../../server-components/icons/ArrowUpRightCircleIcon.js';
import '../../server-components/icons/ArrowsAngleExpandIcon.js';
import '../../server-components/icons/BankIcon.js';
import '../../server-components/icons/CheckIcon.js';
import '../../server-components/icons/ChevronDownIcon.js';
import '../../server-components/icons/ChevronRightIcon.js';
import '../../server-components/icons/ChevronUpIcon.js';
import '../../server-components/icons/CopyIcon.js';
import '../../server-components/icons/CrossIcon.js';
import '../../server-components/icons/DaiIcon.js';
import '../../server-components/icons/DangerIcon.js';
import '../../server-components/icons/DownSortIcon.js';
import '../../server-components/icons/ExclamationTriangleIcon.js';
import '../../server-components/icons/ExpandKpiIcon.js';
import '../../server-components/icons/EyeIcon.js';
import '../../server-components/icons/EyeSlashIcon.js';
import '../../server-components/icons/Grid1x2Icon.js';
import '../../server-components/icons/InfoCircleIcon.js';
import '../../server-components/icons/ListIcon.js';
import '../../server-components/icons/LockIcon.js';
import '../../server-components/icons/MediumIcon.js';
import '../../server-components/icons/MoonIcon.js';
import '../../server-components/icons/PiggyBankIcon.js';
import QuestionMarkCircleIcon from '../../server-components/icons/QuestionMarkCircleIcon.js';
import '../../server-components/icons/ShieldIcon.js';
import '../../server-components/icons/SunIcon.js';
import '../../server-components/icons/UpSortIcon.js';
import '../../server-components/icons/XIcon.js';
import '../../server-components/Table/Table.module.scss.js';
import '../../server-components/Table/components/TableRow.module.scss.js';
import '../../server-components/Table/components/Pagination.module.scss.js';
import '../../server-components/Text/Text.js';
import '../../server-components/Table/components/TableCell/TableCell.module.scss.js';
import '../../server-components/Card/Card.module.scss.js';
import '../../server-components/List/List.module.scss.js';
import '../../server-components/ErrorBox/ErrorBox.module.scss.js';
import '../../server-components/InfoBox/InfoBox.module.scss.js';
import '../../server-components/KpiCard/KpiCard.module.scss.js';
import '../../server-components/TrendValue/TrendValue.module.scss.js';
import '../../server-components/Modal/Modal.module.scss.js';
import '../ThemeProvider.js';
import '../Tabs/Tabs.module.scss.js';
import '../ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../ExpandableCard/ExpandableCard.module.scss.js';
import '../ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import 'luxon';
import '../WalletAddress/WalletAddress.module.scss.js';
import '../filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../FormattedCurrency/FormattedCurrency.js';
import '../FormattedPercentage/FormattedPercentage.js';
import '../CurrencyValue/CurrencyValue.module.scss.js';
import '../PercentageValue/PercentageValue.module.scss.js';
import '../DisplaySwitch/DisplaySwitch.module.scss.js';
import '../Tooltip/Tooltip.js';
import 'lodash';
import '../charts/ChartJS.js';
import '../charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../charts/BarChart/BarChart.module.scss.js';
import '../charts/LineChart/LineChart.module.scss.js';
import '../charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../Checkbox/Checkbox.module.scss.js';
import '../../server-components/Badge/Badge.module.scss.js';
import '../../server-components/HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../server-components/Switch/Switch.module.scss.js';
import '../../server-components/Select/Select.module.scss.js';
import '../../server-components/pictograms/EthPictogram.js';
import '../../server-components/pictograms/EtherScanPictogram.js';
import '../../server-components/pictograms/DebankPictogram.js';
import '../../server-components/pictograms/ZapperPictogram.js';
import '../../server-components/pictograms/DaiPictogram.js';
import 'react-loading-skeleton';

const sizeMap = {
    xSmall: 12,
    small: 16,
    medium: 20,
    large: 24
};
const baseUrl = 'https://icons.blockanalitica.com/crypto';
const CryptoIcon = ({ name, size = 'medium', options, extension = 'svg', ...rest }) => {
    const [error, setError] = useState(null);
    const imgSize = useMemo(() => (typeof size === 'string' ? sizeMap[size] : size), [size]);
    const mergedOptions = useMemo(() => ({
        fallback: jsx(QuestionMarkCircleIcon, { size: imgSize }),
        opacity: 1,
        ...options
    }), [imgSize, options]);
    const src = useMemo(() => `${baseUrl}/${extension}/${name.toLowerCase()}.${extension}`, [name, extension]);
    if (error) {
        console.error(error);
        return (jsx(Flex, { role: "img", "aria-label": `${name} Icon`, ...rest, children: mergedOptions.fallback }));
    }
    return (jsx(Flex, { role: "img", "aria-label": `${name} Icon`, opacity: mergedOptions.opacity, ...rest, children: jsx(Box, { as: "img", alignSelf: "center", 
            //@ts-ignore
            src: src, alt: name, width: imgSize + 'px', height: imgSize + 'px', loading: "lazy", onError: () => setError(new Error()) }) }));
};

export { CryptoIcon as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
